import { Badge, BadgeProps, styled } from "@mui/material";

interface ContadorBadgeProps {
    color?: string;
    bgColor?: string;
    contador?: number;
    children?: React.ReactNode;
    fontSize?: string;
    title?: string;
    showZero?: boolean;
}

const ContadorBadge: React.FC<ContadorBadgeProps> = (props) => {

    const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
        "& .MuiBadge-badge": {
            border: `2px solid ${theme.palette.background.paper}`,
            padding: "0 4px",
            background: props.bgColor || "#ed5565",
            color: props.color || "#ffffff",
            fontSize: props.fontSize || "11px",
            
        },
        margin: "10px",
    }));  

    return (
        <StyledBadge showZero={props.showZero} badgeContent={props.contador} title={props.title}>
            {props.children}
        </StyledBadge>
    );
}
export default ContadorBadge;